import { DashboardSettings } from '@/pages/DashboardSettings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/settings')({
  component: DashboardSettings,
  meta: () => [{ title: 'Settings' }],
})
